<tlk-modal-header [id]="'tooth-editor-header'" class="rx-modal">
	<button tlkButton id="back-button" variant="ghost" size="l" left-icon (click)="handleApply()">
		<tlk-chevron-left-icon id="back-icon" class="tlk-icon_size_l" tabindex="-1"/>
	</button>
	<div id="unit-type-name-title">{{ unitTypeName }}</div>
	<rx-bridge-range-selector *ngIf="isBridge" [isReadOnly]="isReadOnly"></rx-bridge-range-selector>
</tlk-modal-header>